import * as React from "react";
import { Activity } from "lucide-react";
export default function UnderstandingYourCondition() {
  return <section className="bg-background py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-lg bg-primary/10 mb-6">
            <Activity className="w-8 h-8 text-primary" />
          </div>
          
          <h1 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-6 tracking-wide">
            MSK Conditions We Treat in Doncaster
          </h1>
          
          <p className="text-base md:text-lg leading-relaxed text-muted-foreground">
            At Align Physiotherapy, we specialise in treating a wide range of musculoskeletal conditions including Back Pain, Knee Osteoarthritis, Shoulder Pain, and Sports Injuries. Our evidence-based approach ensures that each treatment plan is tailored to your specific needs, helping you understand your condition and empowering you to take an active role in your recovery journey.
          </p>
        </div>
      </div>
    </section>;
}